import { Route } from '@angular/router';
import { authRedirectGuard } from './guards/auth-redirect.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./features/sign-in/sign-in.component').then(m => m.SignInComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/password',
    loadComponent: () => import('./features/sign-in/password/password.component').then(m => m.PasswordComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/forgot-password',
    loadComponent: () => import('./features/sign-in/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/otp',
    loadComponent: () => import('./features/sign-in/otp/otp.component').then(m => m.OtpComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/reset-password',
    loadComponent: () => import('./features/sign-in/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/reset-password-success',
    loadComponent: () => import('./features/sign-in/reset-password-success/reset-password-success.component').then(m => m.ResetPasswordSuccessComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/verify-phone',
    loadComponent: () => import('./features/sign-in/verify-phone/verify-phone.component').then(m => m.VerifyPhoneComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/set-password',
    loadComponent: () => import('./features/sign-in/set-password/set-password.component').then(m => m.SetPasswordComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/invitation-success',
    loadComponent: () => import('./features/sign-in/invitation-success/invitation-success.component').then(m => m.InvitationSuccessComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/invitation-expired',
    loadComponent: () => import('./features/sign-in/invitation-expired/invitation-expired.component').then(m => m.InvitationExpiredComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/account-exists',
    loadComponent: () => import('./features/sign-in/account-exists/account-exists.component').then(m => m.AccountExistsComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/already-signed-in',
    loadComponent: () => import('./features/sign-in/already-signed-in/already-signed-in.component').then(m => m.AlreadySignedInComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/sso',
    loadComponent: () => import('./features/sign-in/sso/sso.component').then(m => m.SsoComponent),
    canActivate: [authRedirectGuard]
  },
  {
    path: 'sign-in/cant-sign-in-sso',
    loadComponent: () => import('./features/sign-in/cant-sign-in-sso/cant-sign-in-sso.component').then(m => m.CantSignInSsoComponent),
    canActivate: [authRedirectGuard]
  }
];
